import { RouteComponentProps } from '@reach/router';
import { LandingContainer } from '../../container';


const LandingPage :any = (props: RouteComponentProps) => {
  return <LandingContainer/>
};

export default LandingPage;
